import script from "./loginCard.vue?vue&type=script&setup=true&lang=js"
export * from "./loginCard.vue?vue&type=script&setup=true&lang=js"

import "./loginCard.vue?vue&type=style&index=0&id=283c153b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283c153b"]])

export default __exports__